import { render, staticRenderFns } from "./WrenwoodComingSoon.vue?vue&type=template&id=208cc940"
import script from "./WrenwoodComingSoon.vue?vue&type=script&setup=true&lang=ts"
export * from "./WrenwoodComingSoon.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WrenwoodComingSoon.vue?vue&type=style&index=0&id=208cc940&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports